<template>
  <Input
    :type="item.inputType"
    v-model="item.value"
    :placeholder="item.placeholder"
    :disabled="item.disabled"
    :autosize="item.autosize"
    :readonly="readonly"
    :password="item.inputType === 'password'"
    :maxlength="item.maxlength"
    :show-word-limit="item.showWordLimit"
    @on-focus="() => { item.onFocus && item.onFocus(item, formItems) }"
  />
</template>
<script>
import props from './props'
export default {
  name: 'form-item-input',
  mixins: [props],
  data () {
    return {}
  }
}
</script>